module.exports = __webpack_public_path__ + "static/one_breath-signup-OG-748fd5285d87f61d4344d06930a83c4a.jpg";